import React, {useEffect, useRef, useState} from "react";
import moment from "moment";
import "moment/locale/fr";

import '../cesu/FormulaireCesu.scss';
import {AncvService} from "../../../service/AncvService";
import {ClapService} from "../../../service/ClapService";
import {useSelector} from "react-redux";
import {Accordion, AccordionTab} from "primereact/accordion";
import {FieldBuilder} from "../fields/FieldBuilder";
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import {ChequeCultureService} from "../../../service/ChequeCultureService";
import {LinkProviderService} from "../../../service/LinkProviderService";
import {FileService} from "../../../service/FileService";
import {ParamModuleService} from "../../../service/ParamModuleService";
import {Dropdown} from "primereact/dropdown";
import LoaderDots from '../fields/LoaderDots';


export const FormulaireCesuMulti = ({mode, hiddenNoticeButton, onConfirm, oldForm}) => {

    const user = useSelector((state) => state.usager.user);
    const actionSociale = useSelector((state) => state.actionSociale);
    const [currentActionSociale, setCurrentActionSociale] = useState({});
    const [isEmailNotValid, setIsEmailNotValid] = useState(false);
    const [isAdresseNotValid, setIsAdresseNotValid] = useState(false);

    const [activeIndex, setActiveIndex] = useState([]);
    const [step, setStep] = useState();
    const [justificatifPresence, setJustificatifPresence] = useState(null);
    const [retourJustificatifPresence, setRetourJustificatifPresence] = useState(false);
    const [hideJustificatif, setHideJustficatif] = useState(false);
    const fileUploadRef = useRef(null);

    const [policyOne, setPolicyOne] = useState(false);
    const [policyTwo, setPolicyTwo] = useState(false);
    const [policyThree, setPolicyThree] = useState(false);
    const [isStep1Completed, setIsStep1Completed] = useState(false);
    const [isStep2Completed, setIsStep2Completed] = useState(false);

    const [editCommande, setEditCommande] = useState(true);

    const toast = useRef(null);
    const [displayBasic, setDisplayBasic] = useState(false);
    const [showFileUploadError, setShowFileUploadError] = useState(false);
    const [showDemandeError, setShowDemandeError] = useState(false);
    const [paramCesuMulti, setParamCesuMulti] = useState({});
    

    const [disabled, setDisabled] = useState(false);
    const [codeError, setCodeError] = useState(false);




    const [loaderRecap, setLoaderRecap] = useState(false);
    const [errorMsgRecap, setErrorMsgRecap] = useState(false);
    const [loaderSign, setLoaderSign] = useState(false);
    const [isSignCompleted, setIsSignCompleted] = useState(false);

    const [selectedMontantLabel,setSelectedMontantLabel] = useState(null);







    const MAYOTTE_CODE_DELEGATION="19";
    const MAYOTTE_CLASSIC_RECEPTION_NOTICE=<div><b>Les Chèques-vacances seront adressés à mon établissement qui me préviendra dès réception.</b>
    <br/>Des frais de gestion seront facturés avec le 1er prélèvement. J'ai bien vérifié que l'enseigne accepte les paiements avec le format CLASSIC.</div>;

    const CLASSIC_RECPTION_NOTICE=<div><b>Je recevrai les Chèques-vacances par courrier recommandé.</b>
    <br/>au plus tard le 25 du mois suivant celui du dernier prélèvement. Des frais de gestion seront facturés avec le 1er prélèvement. J'ai bien vérifié que l'enseigne accepte les paiements avec le format CLASSIC.</div>;



    let createMode = "create";
    let editMode = "edit";
    let mimeTypes = ["application/pdf", "image/jpg", "image/jpeg", "image/png"];

    // format nombre en Euro
    let formatEuro = Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
    });

    // format nombre fr
    let formatFr = Intl.NumberFormat('fr-FR', );

    // constitution de la liste des justifs à uploader en cas ce complément d'info
    let libelleJustifToDisplay = [];
    let codeJustifToUploadList = [];
    let cloneJustifToUploadList = [];


    const formatMontant = (value) => {
        return new Intl.NumberFormat('fr-FR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(value);
      };



    const chequeCultureService = new ChequeCultureService();
    const linkService = new LinkProviderService();
    const fileService = new FileService();
    const paramModuleService = new ParamModuleService();

      // Custom item template for DropDown
    const itemTemplate = (option) => {
        return (
        <div
            style={{
            color: option.disabled ? '#999' : 'inherit',
            pointerEvents: option.disabled ? 'none' : 'auto',
            opacity: option.disabled ? 0.7 : 1,
            }}
        >
            {option.name}
        </div>
        );
    };

 

    const selectFormatOptions = [
        {
            name: "DIGITAL, e-CESU Multiservices",
            code: "0",
            disabled:isEmailNotValid
        },
        {
            name: "PAPIER, CESU Multiservices",
            code: "1",
            disabled:false
        },
    ];


    const montantCommandes = [
        {
            name: "50% du montant annuel",
            code: actionSociale?.cesuMultiTaux?.tauxPartiel?.montant,
            taux:actionSociale?.cesuMultiTaux?.tauxPartiel?.taux,
            disabled:false
        },
        {
            name: "100% du montant annuel",
            code: actionSociale?.cesuMultiTaux?.tauxTotal?.montant,
            taux:actionSociale?.cesuMultiTaux?.tauxTotal?.taux,
            disabled:false
        },
    ];

    const calcMontantAndParticipation = (selectedCommande) => {
         if(mode == createMode){
            let frais=paramCesuMulti.fraisAffranchissement;
            let montant =parseInt(selectedCommande);
            let participationCgos= (montant*parseInt(selectedTauxComande))/100;
            let participationAgent=montant-participationCgos;
            let montantTotal=montant+frais;


            setSelectedFullMontantComande({
                frais: formatMontant(frais),
                montant: formatMontant(montant),
                participationCgos: formatMontant(participationCgos),
                participationAgent: formatMontant(participationAgent),
                montantTotal: formatMontant(montantTotal)
              });    
         }       

    };





    const justificatifsCategories = [
        {
            "key": "106",
            "value": "Justificatif de présence en établissement",
            "description": "Bulletin de paie ou attestation de travail de moins d’un mois ou décision administrative de congés parental à 100%."
        }
    ];

    const text = <div><strong><p>POLITIQUE DE PROTECTION DES DONNÉES À CARACTÈRE PERSONNEL</p></strong><br />
        <p>J'ai bien noté que les données à caractère personnel renseignées dans ce formulaire seront recueillies et traitées par le C.G.O.S pour la gestion des demandes d'actions et de prestations.</p>
        <p>Elles pourront également être transmises, si nécessaire pour l'exécution des demandes d'actions et de prestations et pour le respect par le C.G.O.S de ses obligations légales et règlementaires, à des tiers fournisseurs des actions et prestations, sous-traitants du C.G.O.S notamment pour la gestion informatique et financière, en cas d'obligation légale aux autorités publiques, commissaires aux comptes, avocats, experts-comptables.</p>
        <p>Si certains de ces destinataires devaient se situer en dehors de l'Union Européenne, le C.G.O.S concevra des garanties spécifiques pour assurer la protection de vos données.</p>
        <p>Les informations collectées sont conservées tout au long de votre adhésion, puis à l'expiration de celle-ci pendant le délai de prescription.</p>
        <p>Conformément au Règlement (UE) 2016/679 du Parlement européen et du Conseil sur les données (ci-après « RGPD ») et à la loi n° 78/17 du 6 janvier 1978 modifiée, relative à l'informatique, aux fichiers et aux libertés, je dispose d'un droit d'accès, de rectification, d'effacement, d'opposition et de portabilité de l'ensemble des données me concernant collectées par le C.G.O.S, en tant que responsable de traitement.</p>
        <p>Pour exercer ce droit ou pour toute réclamation, je peux adresser un courrier au C.G.O.S à l'attention du Délégué à la Protection des Données : 101 rue de Tolbiac, 75654 PARIS CEDEX 13, ou un mail à l'adresse : dpd@cgos.asso.fr, en joignant à mon envoi par voie postale ou par mail une copie d'un titre d'identité.</p>
    </div>

    const editJustificatifMsg = ''

    const [cesuType, setCesuType] = useState(null);
    const [selectedMontantComande, setSelectedMontantComande] = useState(null);
    const [selectedMontantComandeLibelle, setSelectedMontantComandeLibelle] = useState(null);
    const [selectedTauxComande, setSelectedTauxComande] = useState(null);

    const [selectedFullMontantComande, setSelectedFullMontantComande] = useState(null);

    useEffect(() => {
        if(createMode === mode) {
          fetchDataForCreation()
        } else if (editMode === mode) {
          fetchDataForEdition();
        } else {
          window.location.assign(linkService.getRetourEaLoginAgent());
        }
        if(!user.email){
            setIsEmailNotValid(true);
        }
    }, []);

    useEffect(() => {
        // si le tab suivant est l'affichage du preview, on désactive le simulateur pour figer les données
        if(step === 4) {
            setActiveIndex(prevState => [...prevState.filter(i => i !== 1), step]);
            if(hideJustificatif ||(editMode === mode && retourJustificatifPresence )){
                setActiveIndex(prevState => [...prevState.filter(i => i !== 2), step]);
            }
        } else {
            setActiveIndex(prevState => [...prevState, step]);
        }
        console.log("step changed to " + step);
    }, [step]);

    useEffect(() => {
            initActiveIndex();
            setStep(0);
    }, []);





    const floatsAreEqual = (a, b, epsilon = 1e-10) => {
            return Math.abs(a - b) < epsilon;
    }


    const fetchDataForCreation = () => {
        getCurrentActionSociale();
        getJustificatifRequis();
        getparamsCesuMulti();
    };


    const getparamsCesuMulti = async () => {
        paramModuleService.getParamCesuMulti()
            .then((res) => {
                setParamCesuMulti(res.data[0]);
            })
            .catch((error) => {
                console.log(error);
            });
    };


    const  isPastDate =(dateStr)=> {
        const [day, month, year] = dateStr.map(Number);
        const inputDate = new Date(year, month - 1, day);
        const now = new Date();
        now.setHours(0, 0, 0, 0);
        return inputDate < now;
    }

    const fetchDataForEdition = () => {
         chequeCultureService.getEditDto().then((form) => {
            const oldForm=form.data;
            let jsonObj = JSON.parse(oldForm.formJson);
            /*
               {
                    "code": "FORMAT_TITRES_CESU_MULTI",
                    "valeur": cesuType === "0" ? "e-CESU" : "PAPIER",
                },
                {
                    "code": "TYPE_COMMANDE_CESU_MULTI",
                    "valeur": montantCommandes.find(item => item.code === selectedMontantComande),
                },
                {
                    "code": "QF_CESU_MULTI",
                    "valeur": actionSociale.fiche.quotientFamilial !== null ? actionSociale.fiche.quotientFamilial?.toString() : 'N.C.',
                },
                {
                    "code": "PARTICIP_CGOS_P_CESU_MULTI",
                    "valeur": paramCesuMulti.pourcentagePartCgos,
                },
                {
                    "code": "PARTICIP_CGOS_E_CESU_MULTI",
                    "valeur": selectedFullMontantComande.participationCgos,
                },
                {
                    "code": "PARTICIP_AGENT_CB_CESU_MULTI",
                    "valeur": selectedFullMontantComande.participationAgent,
                },
                {
                    "code": "MONTANT_TOTAL_CESU_MULTI",
                    "valeur": selectedFullMontantComande.participationAgent,
                }
            */

            let extractedCesuType=jsonObj.FORMULAIRE[0].VALEUR;
            setCesuType(extractedCesuType === "e-CESU" ? "0" : "1");
            let extractedTypeCommande=jsonObj.FORMULAIRE[1].VALEUR;
            let selectedMontantCommandeRaw=montantCommandes.find(item => item.name.toUpperCase() === extractedTypeCommande);
            setSelectedMontantComande(selectedMontantCommandeRaw.code);
            setSelectedMontantComandeLibelle(extractedTypeCommande);    
            let participationCgos=parseFloat(jsonObj.FORMULAIRE[4].VALEUR);
            let participationAgent=parseFloat(jsonObj.FORMULAIRE[5].VALEUR);
            let montantTotal=parseFloat(jsonObj.FORMULAIRE[6].VALEUR);
            let frais=montantTotal-(participationCgos+participationAgent);
            let montant =participationAgent;
            setSelectedFullMontantComande({
                frais: formatMontant(frais),
                montant: formatMontant(montant),
                participationCgos: formatMontant(participationCgos),
                participationAgent: formatMontant(participationAgent),
                montantTotal: formatMontant(montantTotal)
              });

            setSelectedMontantLabel(selectedMontantCommandeRaw?.name);   
            setIsStep1Completed(true);
            setIsStep2Completed(true);



            Object.values(oldForm.filesToUpload).forEach(file => {
            if(file.codeJustificatif === '106') {
                 setRetourJustificatifPresence(true);
              }
            });

            getCurrentActionSociale();
            getJustificatifRequis();
            getparamsCesuMulti();

        });
    }


    const getCurrentActionSociale = () => {
        if((mode == editMode && actionSociale.listActionsSociale.length == 0)){
           let defaultActionSocial={codeActionSociale: "3952",codeLibelle: "CESU - MULTISERVICE",
             dateDebut: "2026",dateFin: "2026",codeDelegation: user.codeDelegation ,exercice: "2026",defaultEditMode:true
                                                }
             setCurrentActionSociale(defaultActionSocial);
             return;
        }
        Object.values(actionSociale.listActionsSociale).forEach((as) => {
            if (
                as.codeActionSociale === actionSociale.cas &&
                as.exercice === actionSociale.exercice
            ) {
                setCurrentActionSociale(as);
              
                return;
            }
        });
    };


    const getJustificatifRequis = async () => {
        chequeCultureService
            .getJustificatifRequis()
            .then((res) => {
                setHideJustficatif(res.data);
            })
            .catch((error) => {
                console.log(error);
            });
    };





    const initActiveIndex = () => {
        if (createMode === mode) setActiveIndex([0]);
        if (editMode === mode) setActiveIndex([1,2]);
    };

    const nextStep = (element, increment) => {
        element.disabled = true;
        element.classList.add("disabled");
        element.style.pointerEvents = "none";
        element.style.display = "none";
        setStep(step + increment);
    };

    const showInfo = (msg) => {
        toast.current.show({
            severity: "info",
            summary: "Succès",
            detail: msg + " envoyée avec succès. ",
            life: 5000,
        });
    };

    const showErrorApi = (msg) => {
            toast.current.show({
                severity: "error",
                summary: "Error",
                detail: "Une erreur est survenue. Nous faisons tout notre possible pour régler rapidement le problème. Merci de réessayer un peu plus tard",
                err: msg,
                life: 5000,
            });
   };

    const isInViewport = (element) => {
        requestAnimationFrame(() => {
            const rect = element.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
            );
        })
    };

    const scrollIfNotVisible = (ref) => {
        const el = ref.current;
        if (el && !isInViewport(el)) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };

    const scrollBottomIfNotVisible = () => {
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }

    const handleChangeFormat = (value) => {
        setCesuType(value);
        setIsStep1Completed(value !== null);
 
    };

    const handleChangeMontant = (e) => {
        const value = e.value;

        const selectedItem = montantCommandes.find(
            (item) => item.code === value
        );
    
        setSelectedMontantComande(value);
        setSelectedTauxComande(selectedItem?.taux || null);
        setSelectedMontantLabel(selectedItem?.name || null); 
        setIsStep2Completed(value !== null);
    };


    useEffect(() => {
        if (!selectedMontantComande) return;
    
        calcMontantAndParticipation(selectedMontantComande);
    }, [selectedMontantComande]);

    





    const submitFormDemande = async (e) => {
        e.preventDefault();
        if(e.detail == 1) {
            let fiche = actionSociale.fiche;
            const jsonFormSchemaJustif = {
                formulaire: [
                    {
                        "code": "FORMAT_TITRES_CESU_MULTI",
                        "valeur": cesuType === "0" ? "e-CESU" : "CESU",
                    },
                    {
                        "code": "TYPE_COMMANDE_CESU_MULTI",
                        "valeur": montantCommandes.find(item => item.code === selectedMontantComande).name,
                    },
                    {
                        "code": "QF_CESU_MULTI",
                        "valeur": actionSociale.fiche.quotientFamilial !== null ? actionSociale.fiche.quotientFamilial?.toString() : 'N.C.',
                    },
                    {
                        "code": "PARTICIP_CGOS_P_CESU_MULTI",
                        "valeur": paramCesuMulti.pourcentagePartCgos.toString().replace(",", "."),
                    },
                    {
                        "code": "PARTICIP_CGOS_E_CESU_MULTI",
                        "valeur": selectedFullMontantComande.participationCgos.toString().replace(",", "."),
                    },
                    {
                        "code": "PARTICIP_AGENT_CB_CESU_MULTI",
                        "valeur": selectedFullMontantComande.participationAgent.toString().replace(",", "."),
                    },
                    {
                        "code": "MONTANT_TOTAL_CESU_MULTI",
                        "valeur": selectedFullMontantComande.montantTotal.toString().replace(",", ".")
                    }
                ]
            };


            const demandeDetail = {
                id: editMode === mode ? oldForm.demandeDetailId : "",
                demandeType: {
                    codeActionSocial: editMode === mode ? oldForm.codeActionSociale : actionSociale.cas,
                },
                motif: cesuType === "0" ? "e-CESU" : "PAPIER",
                formJson: editMode === mode ? oldForm.formJson : JSON.stringify(jsonFormSchemaJustif).toUpperCase(),
                montant: selectedFullMontantComande.participationAgent.toString().replace(",", "."),
                version: "1",
            };

            let justificatifsPresenceList = [];

            if ((actionSociale.optJustificatif || (editMode == mode)) && justificatifPresence && justificatifPresence.length > 0) {
                Object.values(justificatifPresence).forEach(jus => {
                    justificatifsPresenceList.push(jus.category[1]);
                });
            }


            const demande = {
                demandeId: editMode == mode ? oldForm.demandeId : "",
                demandeDetails: [],
                ...(editMode !== mode && {
                    etape: "1",
                    statut: "A_VALIDER",
                    demandeStatutReferentiel: {id: 1},
                    origine: "NEA",
                    exercice: actionSociale.exercice,
                    codeClasseur: actionSociale.cas,
                    numeroCGOS: actionSociale.fiche.numCgos
                }),
                ...(editMode == mode && {
                    recordId: oldForm.recordId,
                    filesToUpload: oldForm.filesToUpload,
                    formJson: JSON.stringify(jsonFormSchemaJustif).toUpperCase(),
                    codeActionSociale: oldForm.codeActionSociale,
                    exercice: oldForm.exercice
                }),
            };


            demande.demandeDetails.push(demandeDetail);

            const infosDemandeCesuDto = {
                "exercice": actionSociale.exercice,
                "libelleActionSociale": "CESU Multiservices",
                "numCgos": fiche.numCgos,
                "codeActionSociale": actionSociale.cas,
                "emailPersonnel": fiche.email,
                "justificatifsPresence": justificatifsPresenceList,
                "nom": fiche.nom,
                "nomNaissance": fiche.nomNaissance,
                "prenom": fiche.prenom,
                "qf": fiche.quotientFamilial,
                "etbLibelle": fiche.libelleEtablissement,
                "etbCode": fiche.codeEtablissement,
                "adressePersonnel": [fiche.adresse.adresse3, fiche.adresse.codePostal, fiche.adresse.ville, fiche.adresse.adresse1, fiche.adresse.adresse2, fiche.adresse.adresse4].filter(Boolean).join(" "),
                "formatTitre": selectFormatOptions[parseInt(cesuType)].name,
                "typeCommande": montantCommandes.find(item => item.code === selectedMontantComande).name,
                "participationCgosE": selectedFullMontantComande.participationCgos.toString().replace(",", "."),
                "participationCgosP": paramCesuMulti.pourcentagePartCgos,
                "participationAgent": selectedFullMontantComande.participationAgent.toString().replace(",", "."),
                "montantTotal": selectedFullMontantComande.montantTotal.toString().replace(",", ".")
            };

            if (hideJustificatif) {
                if (justificatifPresence && justificatifPresence.length > 0) {
                    setDisabled(true);
                    fileService
                        .uploadMultiFile(justificatifPresence)
                        .then((res) => {
                            if (null != res.data && res.data != undefined) {
                                fileService.createRecapDemande(infosDemandeCesuDto).then((response) => {
                                    //showInfo("Justificatif");
                                    editMode === mode ? saveEditedDemande(demande) : saveDemande(demande);
                                });
                            } else {
                                setShowFileUploadError(true);
                            }
                        })
                        .catch((err) => {
                            window.location =
                                "/#/serviceIndisponible/" + err.response.data.errorId;
                        });
                } else {
                    // showInfo("Justificatif");
                    editMode === mode ? saveEditedDemande(demande) : saveDemande(demande);

                }
                ;
            } else {
                fileService.createRecapDemande(infosDemandeCesuDto).then((response) => {
                    //showInfo("Justificatif");
                    editMode === mode ? saveEditedDemande(demande) : saveDemande(demande);
                });
            }
        }
    };

    const saveDemande = async (demande) => {
        await chequeCultureService
            .submitDemandeForm(demande)
            .then((res) => {
                setDisplayBasic(true);
                }).catch((err) => {
                    window.location =
                  "/#/serviceIndisponible/" + err.response.data.errorId;
                });


    };


    const saveEditedDemande = async (demande) => {
       await chequeCultureService
            .submitEditedForm(demande)
            .then((res) => {
                setDisplayBasic(true);
            })
            .catch((err) => {
                window.location =
                  "/#/serviceIndisponible/" + err.response.data.errorId;
            });
    };



    const handleAnnuler = () => {
        chequeCultureService.redirectEaLegacy();
    };

    const onPolicyOneChange = () => {
        setPolicyOne(!policyOne);
    };

    const onPolicyTwoChange = () => {
        setPolicyTwo(!policyTwo);
    };
    const onPolicyThreeChange = () => {
        setPolicyThree(!policyThree);
    };

    const logoutRemoveDataMesSuivis = (e) => {
        chequeCultureService.logOut().then((res) => {
            console.log(res);
        });
        chequeCultureService.redirectEaLegacySuiviDemandes();
    };

    const logoutRemoveData = (e) => {
        chequeCultureService.logOut().then((res) => {
            console.log(res);
        });
        handleAnnuler();
    };


     const basicDialogFooter = (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
            
            <button
                type="button"
                onClick={(e) => logoutRemoveData(e)}
                className="retour-accueil-btn"
                id="retour-accueil"
                style={{color: '#333031', backgroundColor: '#ffffff', border: '1px solid #333031', padding: '0.5rem 1rem', fontSize: '1rem', borderRadius: '5px'}}
                >
                RETOUR A L'ACCUEIL
            </button>

            <button
                type="button"
                onClick={(e) => logoutRemoveDataMesSuivis(e)}
                className="mes-suivis-btn"
                id="mes-suivis"
                style={{color: '#ffffff', backgroundColor: '#2A7D93', border: '1px solid #999898', padding: '0.5rem 1rem', fontSize: '1rem', borderRadius: '5px'}}
                >
                MES SUIVIS
            </button>
        </div>
      );

    return (
        <div className="content-wrapper">
            <form onSubmit={(e) => e.preventDefault()} aria-label="Formulaire chèques-vacances">
                {editMode === mode &&  (
                <>
                      <div className="error">
                          {libelleJustifToDisplay.length > 0 && (
                              <>
                                Observations du C.G.O.S sur les documents déjà transmis :
                                {Object.entries(libelleJustifToDisplay).map(([key, val]) => (
                                    <li>{val}</li>
                                ))}
                                <br/>
                                <br/>
                              </>

                          )}

                          {oldForm && oldForm.noteRetourAgent && (
                              <>
                                Autre commentaire ou document complémentaire à nous envoyer :
                                <p>{oldForm.noteRetourAgent}</p>
                                <br/>
                              </>
                          )}

                              <b>Merci de renvoyer dans ce formulaire, après correction, les documents indiqués ci-dessous</b>.

                     </div>
                     <div className="form-row-separator-20"/>
                </>
                          )}

           
                    <>
{/*                         <p className="error">
                            <b>Problème technique inattendu !</b><br/>
                            Le formulaire ne peut pas être affiché pour l’instant.<br/><br/>
                            Essayez à un autre moment.<br/>
                            Ou cliquez sur {' '} <a href={linkService.getRetourEaMembrePrestation()} className="clickable-link">PRESTATION ET FORMULAIRES</a> et réessayer maintenant.
                        </p> */}
                        <div className="form-row-separator-10"></div>
                    </>
           
             

                <Accordion activeIndex={activeIndex} multiple onTabChange={(e) => setActiveIndex(e.index)}>

                    <AccordionTab headerClassName="cgos-h3" header="1 - Je contrôle mes informations personnelles" disabled={true}>
                        <div>
                            <p className="success">
                                <b>INFO</b> : si certaines informations ne sont pas à jour, modifiez-les depuis la{' '}
                                <a href={linkService.getRetourEaMesInfo()} className="clickable-link">rubrique Mes infos</a>, ou{' '}
                                <a href={linkService.getRetourEaContacterNousChangeSituations()} className="clickable-link">Prévenir d’un changement de situation</a>.<br/>
                                Attendez-ensuite quelques jours, puis demandez votre prestation en ligne.​
                            </p>
                        </div>

                        <div className="form-row-separator-20"></div>

                        {/* Step 0: Identite */}
                        <div className="form-row">
                            <div className="form-block-wrapper info-perso" role="region" aria-labelledby="identity-legend">
                                <table>
                                    <thead>
                                        <tr>
                                            <th id="identity-legend" colSpan="2">Mes informations personnelles</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Numéro C.G.O.S</td>
                                            <td>{user.numCgos}</td>
                                        </tr>
                                        <tr>
                                            <td>Établissement</td>
                                            <td>{user.libelleEtablissement}</td>
                                        </tr>
                                        <tr>
                                            <td>Prénom</td>
                                            <td>{user.prenom}</td>
                                        </tr>
                                        <tr>
                                            <td>Nom</td>
                                            <td>{user.nom}</td>
                                        </tr>
                                        <tr>
                                            <td>Nom de naissance</td>
                                            <td>{user.nomNaissance}</td>
                                        </tr>
                                        <tr>
                                            <td>Email personnel</td>
                                            <td>{user.email}</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                            <div className="form-block-info">
                               <p className="help-important">
                                  <b>IMPORTANT : Si ce n’est pas déjà fait, remplacez impérativement votre email professionnel par un email personnel.</b><br/>
                                  Sinon les informations pour vos CESU pourraient être bloquées par la sécurité informatique de votre établissement.
                                  Cela garantit aussi la confidentialité et le suivi si vous changez d’établissement.<br/>
                                  Changez d'email depuis la rubrique  <a href={linkService.getEaModificationMail()} style={{ color: 'blue' }}>Mes Infos > Modifier mon adresse email.</a>
                               </p>

                               {isEmailNotValid && (
                                    <p className="help">
                                    <b>Pour commander des e-CESU vous devez d'abord transmettre une adresse email.</b><br />
                                    Cet email sera utilisé pour vous envoyer vos codes d'accès à l'espace bénéficiaires Upcoop en ligne.<br />
                                    Pour transmettre votre email allez à la rubrique <a href={linkService.getEaModificationMail()} style={{ color: 'blue' }}>Mes Infos > Données personnelles.</a>
                                    </p>
                                )}

                            </div>


                        </div>

                        <div className="form-row-separator-10"></div>

                        {/* Step 0: Adresse */}
                        <div className="form-row">
                            <div className="form-block-wrapper info-perso" role="region" aria-labelledby="address-legend">
                                <table>
                                    <thead>
                                    <tr>
                                        <th id="address-legend" colSpan="2">Mon adresse personnelle</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>N° et voie</td>
                                        <td>{user?.adresse?.adresse3}</td>
                                    </tr>
                                    <tr>
                                        <td>Lieu-dit</td>
                                        <td>{user?.adresse?.adresse4}</td>
                                    </tr>
                                    <tr>
                                        <td>Ville</td>
                                        <td>{user?.adresse?.ville}</td>
                                    </tr>
                                    <tr>
                                        <td>Pays</td>
                                        <td>{user?.adresse?.pays}</td>
                                    </tr>
                                    <tr>
                                        <td>Code postal</td>
                                        <td>{user?.adresse?.codePostal}</td>
                                    </tr>
                                    <tr>
                                        <td>Apprt., escalier</td>
                                        <td>{user?.adresse?.adresse1}</td>
                                    </tr>
                                    <tr>
                                        <td>Bâtiment, entrée, résidence</td>
                                        <td>{user?.adresse?.adresse2}</td>
                                    </tr>
                                    </tbody>
                                </table>

                            </div>

                        </div>

                        <div className="form-row-separator-10"></div>

                    

                        {/* Step 0: Quotient familial */}
                        <div className="form-row">
                            <div className="form-block-wrapper info-perso" role="region" aria-labelledby="qf-legend">
                                <table>
                                    <thead>
                                    <tr>
                                        <th id="qf-legend" colSpan="2">Mon quotient familial</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>Quotient Familial (QF)</td>
                                        <td>{actionSociale.fiche.quotientFamilial !== null ? actionSociale.fiche.quotientFamilial : 'N.C.'}</td>
                                    </tr>
                                    </tbody>
                                </table>

                            </div>
                            {(!actionSociale.fiche.quotientFamilial) && <div className="form-block-info">
                                <p className="help">
                                    <b>Lorsque le QF n'est pas connu, la prestation du C.G.O.S est minimale.</b><br/>
                                    Pour bénéficier d'une prestation calculée selon votre quotient familial C.G.O.S, transmettez votre avis d'impôt depuis la rubrique
                                    <a href={linkService.getRetourEaContacterNousChangeSituations()} target="_blank" style={{ color: 'blue' }}>
                                        {" "}Prévenir d’un changement de situation.{" "}
                                    </a>
                                </p>
                            </div>}
                        </div>

                        <div className="form-row-separator-20"></div>

                        {(mode == createMode) && <div className="next-button-wrapper">
                            <button type="button"
                                    className="next-button button-arrow"
                                    onClick={(e) => nextStep(e.target, 1)}>
                                Etape suivante
                            </button>
                        </div>}
                    </AccordionTab>

                    <AccordionTab headerClassName="cgos-h3" header="2 - Je complète ma demande CESU Multiservices" disabled={true}>

                        <div className="form-row-separator-10"></div>

                        {/* Step 1: Format */}
                        <div className="form-row">
                            <fieldset className="form-block-wrapper" aria-labelledby="format-legend">
                                    <legend id="format-legend">
                                        <h4 className="cgos-h4">
                                            Je choisis le format &nbsp;&nbsp;&nbsp;
                                            <span className="select-value">
                                                <Dropdown
                                                    name="format"
                                                    value={cesuType}
                                                    placeholder="Sélectionnez un format"
                                                    options={selectFormatOptions}
                                                    optionLabel="name"
                                                    optionValue="code"
                                                    itemTemplate={itemTemplate}
                                                    onChange={(e) => {
                                                        handleChangeFormat(e.value);
                                                    }}
                                                    disabled={editMode === mode}
                                                    aria-labelledby="format-legend"
                                                />
                                            </span>
                                        </h4>
                                    </legend>

                            </fieldset>

                            <div className="form-block-info">
                                {cesuType && cesuType === "0" && (
                                  <>
                                    <p className="notice">
                                      <b>{"Pour utiliser ce format, je dispose d'un ordinateur ou d'un smartphone récent (5 ans ou moins)"}</b><br />
                                      Avant de choisir ce format, je m’assure que la structure ou l’intervenant l’accepte comme mode de paiement.<br /><br />
                                      Les e-CESU Multiservices seront crédités sur mon compte UPCOOP en ligne. Ce format permet un paiement en ligne au centime près sans risque de perte ou de vol.
                                    </p>
                                  </>
                                )}

                                {cesuType && cesuType === "1" && (
                                    <p className="notice">
                                    <b>{"Je recevrais les chèques papier par courrier. "}</b>Envoi simple sans frais de port.<br />
                                    Avant de choisir ce format, je m’assure que la structure ou l’intervenant l’accepte comme mode de paiement.<br /><br />
                                    Le format CESU Multiservices papier permet également de payer en ligne. il suffit de gratter le code sur le chèque et de créer un compte sur UPCOOP.
                                    </p>
                                )}
                            </div>
                        </div>

                        <div className="form-row-separator-30"></div>

                        
                        
                        <div className="form-row">
                                <fieldset className="form-block-wrapper" aria-labelledby="Enfants-legend">
                                    <div className="format-flex">
                                        <legend id="Montant-legend">
                                            <h4 className="cgos-h4">
                                            Je commande &nbsp;&nbsp;&nbsp;
                                                <span className="select-value">
                                                    <Dropdown
                                                        name="Montant"
                                                        value={selectedMontantComande}
                                                        placeholder={ (editMode == mode) ? selectedMontantComandeLibelle:"Sélectionnez un montant"}
                                                        options={montantCommandes}
                                                        optionLabel="name"
                                                        optionValue="code"
                                                        onChange={(e) => {
                                                            handleChangeMontant(e);
                                                        }}
                                                        disabled={editMode === mode}
                                                        aria-labelledby="montant-legend"
                                                    />
                                                </span>
                                            </h4>
                                        </legend>
                                    </div>
                                </fieldset>
                            <div className="form-block-info">
                            {selectedMontantComande && (
                                  <>
                                    <div className="notice-field">
                                                    {(selectedMontantLabel == montantCommandes[0].name) && <p>
                                                Je commande maintenant la moitié du montant annuel maximum de la prestation. 
                                                Je pourrais commander plus tard l'autre moitié sous réserve qu'il reste du budget disponible à ce moment là.
                                                    </p>}
                                                    {(selectedMontantLabel == montantCommandes[1].name) && <p>
                                                        Je commande en une seule fois le montant maximum annuel de la prestation.
                                                    </p>}
                                                <div className="notice-field-row">
                                                    <p class="field-label">
                                                    Participation du C.G.O.S
                                                    </p>
                                                    <span className="field-value">{selectedFullMontantComande?.participationCgos}€</span>
                                                </div>
                                                <div className="notice-field-row">
                                                    <p class="field-label">
                                                    Montant à payer en carte bancaire
                                                    </p>
                                                    <span className="field-value">{selectedFullMontantComande?.participationAgent}€</span>
                                                </div>
                                                <div className="notice-field-row">
                                                    <p class="field-label">
                                                        <b>CESU Multiservices à recevoir</b>
                                                    </p>
                                                    <span className="field-value">{selectedFullMontantComande?.montant}€</span>
                                                </div>
                                    </div>
                                  </>
                                )}                            
                            </div>
                        </div>
                        <div className="form-row-separator-30"></div>

                        
                        <div className="form-row-separator-30"></div>


                        <div className="form-row-separator-30"></div>

                        <div className="form-row-separator-20"></div>

                        {(createMode === mode)  && (
                        <div className="next-button-wrapper">
                            <button type="button"
                                    className="next-button button-arrow"
                                    style={!selectedMontantComande || !cesuType
                                        ? {pointerEvents: "none"}
                                        : {}}
                                    disabled={!selectedMontantComande || !cesuType}
                                    onClick={(e) => nextStep(e.target, !hideJustificatif ? 2 : 1)}>
                                Etape suivante
                            </button>
                        </div>)}
                        {(editMode === mode && !retourJustificatifPresence)  && (
                            <div className="next-button-wrapper">
                                <button type="button"
                                    className="next-button button-arrow"
                                    style={!selectedMontantComande || !cesuType
                                        ? {pointerEvents: "none"}
                                        : {}}
                                    disabled={!selectedMontantComande || !cesuType}
                                    onClick={(e) => nextStep(e.target, !hideJustificatif ? 3 : 1)}>
                                    Etape suivante
                            </button>
                        </div>)}

                    </AccordionTab>

                    {(hideJustificatif ||(editMode === mode && retourJustificatifPresence ))  && (
                    <AccordionTab className="cgos-h3" header="3 - J'ajoute mon justificatif de présence" disabled={true}>

                        <div className="form-row">
                            <div className="form-block-wrapper form-block-jus" style={{
                                border: editMode === mode && retourJustificatifPresence ? '3px solid #e56d68' : '',
                                display: editMode === mode && !retourJustificatifPresence ? 'none' : ''
                            }}>


                                <div name="jutificatif_area">
                                    <FieldBuilder code={'NEA_JUSTIFICATIF_ANCV'}
                                                  items={[mimeTypes, justificatifsCategories, 10000000, false, mode === editMode ? editJustificatifMsg : null]}
                                                  onValueChange={(e) => setJustificatifPresence(e)}/>
                                </div>

                            </div>

                            <div className="form-block-info">
                                {(editMode === mode && retourJustificatifPresence )  && <p className="error">
                                  <b>Votre justificatif n’était pas conforme</b><br/>
                                  Joindre une copie de votre dernier bulletin de paie ou une attestation de travail ou la décision de congés parental à 100% délivrée par votre établissement.
                               </p>}
                            </div>


                        </div>


                        <dl className="dl-horizontal" style={{display: 'initial'}}></dl>

                        <div className="form-row-separator-20"></div>
                        
                        <div className="next-button-wrapper">
                            <button type="button"
                                    className={!((justificatifPresence || retourJustificatifPresence) && justificatifPresence?.length > 0 )
                                        ? "next-button button-arrow disabled"
                                        : "next-button button-arrow"}
                                    style={!((justificatifPresence || retourJustificatifPresence) && justificatifPresence?.length > 0 )
                                        ? {pointerEvents: "none", cursor: "not-allowed"}
                                        : {}}
                                    onClick={(e) => nextStep(e.target, retourJustificatifPresence ? 3 : 1)}
                                    loading={loaderRecap}
                                    disabled={!((justificatifPresence || retourJustificatifPresence) && justificatifPresence?.length > 0 )}>
                                Etape suivante
                            </button>
                        </div>
                    </AccordionTab>
                    )}

                    <AccordionTab className="cgos-h3" header={(!hideJustificatif ? "3 - " : "4 - ") + "Je vérifie le récapitulatif de ma demande"} disabled={true}>
                        

                        <div className="form-row">
                            <div className="form-block-wrapper info-perso" role="region" aria-labelledby="Modalité-de-participation-et-de-livraison">
                                <table>
                                    <tbody>
                                    <tr>
                                        <td><b>Format des titres</b></td>
                                        {cesuType && (
                                            <td><b>{cesuType ? selectFormatOptions[parseInt(cesuType)].name : ""}</b></td>
                                        )}
                                        {!cesuType && (
                                            <td className="erreur-valeur">A renseigner</td>
                                        )}
                                    </tr>
                                    <tr>
                                        <td>Commande</td>
                                        {selectedFullMontantComande && (
                                            <td>{selectedMontantLabel}</td>
                                         )}
                                        
                                    </tr>
                                    <tr>
                                        <td>Participation du C.G.O.S (euros)</td>
                                        {selectedFullMontantComande && (
                                            <td>{selectedFullMontantComande.participationCgos} euros</td>
                                        )}
                                        
                                    </tr>
                                    <tr>
                                        <td><b>Montant à payer en CB</b><br/>(après validation du C.G.O.S)</td>
                                        {selectedFullMontantComande && (
                                            <td><b>{selectedFullMontantComande.participationAgent} euros</b></td>
                                        )}
                                        
                                    </tr>
                                    <tr>
                                        <td><b>Montant total demandé</b></td>
                                        {selectedFullMontantComande && (
                                            <td><b>{selectedFullMontantComande.montantTotal} euros</b></td>)}
                                    </tr>

                                    
                                    </tbody>
                                </table>


                            </div>
                            <div className="form-block-info">


                            </div>
                        </div>
                        <div className="form-row-separator-10"></div>

                        {(hideJustificatif ||(editMode === mode && retourJustificatifPresence ))  && (
                        <div className="form-row">
                            <div className="form-block-wrapper info-perso" role="region" aria-labelledby="Mes-documents-justificatifs">
                                <table>
                                    <thead>
                                    <tr>
                                        <th id="Mes-documents-justificatifs" colSpan="2">Mes documents justificatifs</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>Justificatif de présence</td>
                                        <td>{justificatifPresence?.length > 0 ? justificatifPresence[0].file.name : ""}</td>
                                    </tr>
                                    </tbody>
                                </table>

                            </div>
                            <div className="form-block-info">


                            </div>
                        </div>)}

                        <div className="form-row-separator-10"></div>

                        <div className="form-row-separator-20"></div>


                        

                        {(!loaderRecap) && (
                            <div className="next-button-wrapper">
                                <button type="button"
                                        className="next-button button-arrow next-button-recap"
                                        
                                        onClick={(e) => {nextStep(e.target,1)
                                        }}
                                        disabled={false}>
                                    Etape suivante
                                </button>
                            </div>
                        )}



                    </AccordionTab>

                    <AccordionTab className="cgos-h3" header={(!hideJustificatif ? "4 - " : "5 - ") + "Je valide et j'envoie ma demande"} disabled={true}>

                        <div>
                            <br />
                            <br />

                            <div id="textarea-ancv-protection-data" style={{backgroundColor: "#ffffff"}}>
                                <span>{text}</span>
                            </div>
                            <br />
                            <div className="alert alert-warning" style={{display: 'flex', color: "#333031", borderWidth: "0 0 0 5px", borderStyle: "solid", borderColor: "#aa873c", padding: '1rem', fontSize: '14px'}}>
                                <label style={{ display: 'flex', gap: '1.75rem', alignItems: 'flex-start'}}>
                                <input
                                    type="checkbox"
                                    id="check1"
                                    onChange={onPolicyOneChange}
                                     style={{
                                        width: '1rem',
                                        height: '1rem',
                                        cursor: 'pointer',
                                        transform: 'scale(1.5)'
                                    }}
                                />{" "}
                                 <span>
                                    <strong>Je déclare sur l’honneur l’EXACTITUDE DES INFORMATIONS CONCERNANT MA SITUATION</strong>professionnelle, familiale et financière et je déclare être informé que quiconque se rend coupable de fraude, production de documents falsifiés comme justificatifs, fausses déclarations est passible des peines d’amendes et/ou d’emprisonnement. <br /><br />
                                    <strong>J’ai lu et j’approuve la POLITIQUE DE GESTION DES DONNÉES À CARACTÈRE PERSONNEL</strong>.<br /><br />
                                </span>
                                </label>
                            </div>
                            <br />
                        </div>
                        <div className="form-group">
                        {(!loaderSign && !isSignCompleted) && (
                            <div className="navButtons">
                                <button
                                    className="annuler-dm-btn"
                                    type="button"
                                    name="RETOUR_PRESTATION"
                                    onClick={logoutRemoveData}
                                >
                                    Annuler cette demande
                                </button>&nbsp;&nbsp;&nbsp;

                            {mode == createMode && (
                                <button
                                    className="btn_submit_modal"
                                    type="button"
                                    onClick={submitFormDemande}
                                    name="ENVOYER_MA_DEMANDE"

                                    disabled={(!policyOne)}

                                >
                                    envoyer ma demande 
                                </button>
                            )}


                            {mode == editMode && (
                                <button
                                   /* disabled={
                                        disabled ||
                                        !policyOne ||
                                        !policyTwo ||
                                        !usager.numCgos
                                    }*/
                                    className="btn_submit_modal"
                                    type="button"
                                    name="ENVOYER_MA_DEMANDE"
                                    onClick={
                                        submitFormDemande}
                                >
                                    envoyer ma demande 
                                </button>
                            )}
                            </div>
                        )}
                        </div>

                        {loaderSign && (
                            <div className="loader">
                                <div className="loader-msg">Envoi de la demande en cours, merci de patienter</div>
                                <div className="form-row-separator-10"></div>
                                <LoaderDots />
                            </div>
                        )}

                        <Dialog
                            closable={false}
                            header=""
                            visible={displayBasic}
                            modal
                            footer={basicDialogFooter}
                        >
                            <center>
                                <h2 style={{color: "#333031"}}>
                                   <b> Votre demande a bien été envoyée au C.G.O.S </b> <br />{" "}
                                </h2>
                                <br />
                                <p style={{color: "#932823"}}>
                                Si le C.G.O.S la valide,
                                <br/>
                                vous recevrez un lien pour aller payer avec votre carte bancaire le montant prévu.
                                </p>
                                 <br />
                                <p style={{color: "#333031"}}>
                                   Suivez son avancement depuis la rubrique "Mes suivis".
                                </p>
                                <br />
                            </center>
                        </Dialog>

                        <Dialog closable={false} header="" visible={showDemandeError} modal>
                            <center>
                                <h2>
                                    Un problème est survenu lors de l'envoi de votre demande de
                                    prestation : <b>{codeError}</b>
                                    <br/>
                                </h2>
                                <br/>
                                <h3>
                                    Pour renvoyer votre demande allez sur le formulaire de demande{" "}
                                </h3>
                                <br/>
                                <br/>
                                <h3>puis cliquez de nouveau sur le bouton d’envoi.</h3>
                                <br/>
                                <Button
                                    type="button"
                                    label="RÉAFFICHER LE FORMULAIRE"
                                    onClick={() => window.location.reload(false)}
                                    className="btn_submit_modal"
                                />
                            </center>
                        </Dialog>

                        <Dialog
                            closable={false}
                            header=""
                            visible={showFileUploadError}
                            modal
                        >
                            <center>
                                <h2>
                                    Echec d'envoi de votre demande de prestation Chèques culture{" "}
                                    <br/>
                                </h2>
                                <br/>
                                <h3>
                                    En raison d’un problème technique : <b>{codeError}</b> les
                                    documents joints à votre demandes n’ont pas pu être
                                    enregistrés.
                                </h3>
                                <br/>
                                <h3>
                                    Merci de nous renvoyer votre demande après vous être assuré
                                    que les documents joints à celle-ci sont conformes aux
                                    caractéristiques (taille, format) indiquées sur le formulaire.
                                </h3>
                                <br/>
                                <Button
                                    type="button"
                                    label="RÉAFFICHER LE FORMULAIRE"
                                    onClick={() => window.location.reload(false)}
                                    className="btn_submit_modal"
                                />
                            </center>
                        </Dialog>
                    </AccordionTab>
                </Accordion>
            </form>

        </div>

    );
};
